import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=a8b008a8&scoped=true&"
import script from "./GroupMenu.vue?vue&type=script&lang=js&"
export * from "./GroupMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&id=a8b008a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b008a8",
  null
  
)

export default component.exports